import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdvanceSearchComponent } from './advance-search.component';
import {FormsModule} from '@angular/forms';
import {AgGridModule} from 'ag-grid-angular';
import {PayorsService} from '../../payors/payors.service';
import {ReservationService} from '../../trip-reservations/reservations.service';
import {RiderService} from '../../riders/rider.service';
import {Trip2ThemeModule} from '../../../trip2-theme/trip2-theme.module';
import { DirectivesModule } from '../../../directives/directives.module';
import {TextMaskModule} from 'angular2-text-mask';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AgGridModule.withComponents([]),
    Trip2ThemeModule,
    DirectivesModule,
    TextMaskModule
  ],
  declarations: [
    AdvanceSearchComponent
  ],
  exports: [
    AdvanceSearchComponent
  ],
  providers: [
    PayorsService,
    ReservationService,
      RiderService
  ]
})
export class AdvanceSearchModule { }



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/advance-search/advance-search.module.ts